import React, { useEffect, useRef } from 'react';
import { API_GATEWAY_URL, AUTH_TOKEN_KEY, CLOCK_WIDGET_URL } from '../api/config';
import { refresh } from '../api/refresh';

// The widget's code lives in attendance-service (client/widget) and is loaded at
// runtime, so fixes deployed there show up here without a rebuild.
function ClockWidgetMount() {
  const ref = useRef(null);

  useEffect(() => {
    if (!CLOCK_WIDGET_URL || document.querySelector('script[data-clock-widget]')) return;
    const script = document.createElement('script');
    script.src = CLOCK_WIDGET_URL;
    script.async = true;
    script.dataset.clockWidget = '';
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (ref.current) ref.current.refreshToken = refresh;
  }, []);

  if (!CLOCK_WIDGET_URL) return null;

  return <anyemp-clock-widget ref={ref} gateway-url={API_GATEWAY_URL} token-key={AUTH_TOKEN_KEY} />;
}

export default ClockWidgetMount;
